import { WorkoutCard } from './workout-card'
import { WorkoutCardCompletedBadge } from './workout-card-completed-badge'
import { WorkoutCardContent } from './workout-card-content'
import { WorkoutCardImage } from './workout-card-image'
import { WorkoutCardMeta } from './workout-card-meta'
import { WorkoutCardTitle } from './workout-card-title'
import React from 'react'
import { Workout } from 'src/dao/core-dao'
import { cn } from 'src/lib/utils'

interface WorkoutCardTrendingProps {
  workout: Workout
  isCompleted?: boolean
  className?: string
  onAction: () => void
}

export const WorkoutCardTrending = ({
  workout,
  isCompleted = false,
  className,
  onAction,
}: WorkoutCardTrendingProps): React.ReactElement => {
  return (
    <WorkoutCard
      workout={workout}
      isCompleted={isCompleted}
      className={cn('flex-1 h-full rounded-md ', className)}
      onAction={onAction}
    >
      <WorkoutCardImage>
        <WorkoutCardContent>
          <WorkoutCardCompletedBadge />
          <div className="flex-1 flex flex-col justify-end">
            <WorkoutCardTitle />
            <WorkoutCardMeta />
          </div>
        </WorkoutCardContent>
      </WorkoutCardImage>
    </WorkoutCard>
  )
}
